import React from 'react';


const steps = [
  "Hold a current Coppini Academy membership.",
  "Sign in, choose your preferred rotation, enter portfolio and artwork details, and select the days you can work a full gallery shift or choose paid staffing coverage. Your edits save automatically.",
  "Applying is free. No payment or card details are required for a new application.",
  "Submit your completed application for jury review.",
  "The board and board consultant review the artist's portfolio and individual artwork, then communicate a decision.",
  "Selected artists complete the gallery agreement and commit to one six-hour shift per month. Members who cannot commit to the shift may choose three $50 payments or one $150 payment for staffing coverage.",
  "When space is available, gallery staff confirm your three-month rotation, assign duty dates for members providing service, and provide delivery instructions. Paid coverage begins only after confirmed placement.",
  "Gallery staff document each piece's condition, install it, display it, then record its removal and confirm pickup.",
];


export const GalleryFutureEntryGuide = ({ applicationsOpen = false, availabilityKnown = true }) => (
  <section className="bg-white" data-testid="gallery-future-entry-guide-section">
    <div className="mx-auto max-w-6xl px-5 py-16 md:px-8 md:py-24">
      <p className="text-xs font-semibold uppercase text-[#7c2434]">How it works</p>
      <h2 className="mt-3 font-gallery-heading text-3xl text-[#17243d]">Ongoing Gallery Rotations: application steps</h2>
      <p className="mt-4 max-w-2xl text-sm leading-6 text-[#5d6470]" data-testid="gallery-future-entry-guide-disclaimer">
        {!availabilityKnown ? 'Check application availability at the top of this page. These steps explain how to prepare.' : applicationsOpen ? 'Applications are open. Your preferred rotation is subject to available space.' : 'Applications are not currently available. These steps explain how to prepare.'}
      </p>
      <ol className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="gallery-future-entry-guide-list">
        {steps.map((step, index) => (
          <li
            key={step}
            className="border-t-2 border-[#7c2434] pt-4"
            data-testid={`gallery-future-entry-step-${index + 1}`}
          >
            <span className="text-xs font-semibold text-[#7c2434]">{String(index + 1).padStart(2, '0')}</span>
            <p className="mt-3 text-sm leading-6 text-[#313a4a]">{step}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
